export default {
  signals: { partial: 'Einige verknüpfte Signale gehören zu Funktionen eines anderen Tarifs; hier siehst du die Verknüpfung mit den verfügbaren.' },
};
